import { render, staticRenderFns } from "./PasswordResetForm.vue?vue&type=template&id=580f09dd"
import script from "./PasswordResetForm.vue?vue&type=script&lang=js"
export * from "./PasswordResetForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports